import { type ExpApiGetInviteesResponse } from '../types';

export const getInviteesFromExpApi = async (
	jiraCloudId: string,
	confluenceCloudId: string,
	pageId: string,
	userId: string,
	accountIds: string[],
): Promise<ExpApiGetInviteesResponse> => {
	const response = await fetch(
		'/gateway/api/growth/invite-on-link-insert-confluence/get-invitees',
		{
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
			},
			body: JSON.stringify({ jiraCloudId, confluenceCloudId, pageId, userId, accountIds }),
		},
	);
	return await response.json();
};
